export function singleCareerPage() {
    document.addEventListener( 'DOMContentLoaded', function () {
        const blocks = document.querySelectorAll('.blockSingleCareer');
        let sidebar__addfile = document.querySelectorAll('.sidebar__addfile');
        let postName = document.getElementById('postName');
        let postNameInput = document.querySelector('.sidebar .wpcf7 .title');
        postNameInput.value = postName.textContent ;
        sidebar__addfile.forEach((singleButton) =>{
          singleButton.addEventListener('click',()=>triggerInput(singleButton),false);
          singleButton.querySelector('input').addEventListener('change',()=>update(singleButton));
        })
        function triggerInput(attr){
          attr.querySelector('input').click();
        }
        function update(val){
          let currentElement = val;
          let currentInput = val.querySelector('input');
          if(currentInput.files[0]){
            currentElement.querySelector('span.text').classList.add('hide');
            let newSpan = document.createElement('span');
            newSpan.setAttribute('class', 'fileName');
            newSpan.textContent = "Plik: " + currentInput.files[0].name;
            currentElement.appendChild(newSpan);   
          }else{
            currentElement.querySelector('span.fileName').remove();
            currentElement.querySelector('span.text').classList.remove('hide');
          }
        }
    })
}